module.exports = __webpack_public_path__ + "img/about2.6726652b.jpg";